/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A value for a trend, either analog, boolean, enum, or null if the value is not present.
 */
export type TrendValue = {
  /**
   * The normalized value, if it was requested.
   */
  analogNormalizedValue?: number | undefined;
  /**
   * The analog value.
   */
  analogValue?: number | undefined;
  /**
   * The boolean value.
   */
  booleanValue?: boolean | undefined;
  /**
   * The enum value.
   */
  enumValue?: string | undefined;
  /**
   * The timestamp of the value.
   */
  timestamp: Date;
};

/** @internal */
export const TrendValue$inboundSchema: z.ZodType<
  TrendValue,
  z.ZodTypeDef,
  unknown
> = z.object({
  analog_normalized_value: types.optional(types.number()),
  analog_value: types.optional(types.number()),
  boolean_value: types.optional(types.boolean()),
  enum_value: types.optional(types.string()),
  timestamp: types.date(),
}).transform((v) => {
  return remap$(v, {
    "analog_normalized_value": "analogNormalizedValue",
    "analog_value": "analogValue",
    "boolean_value": "booleanValue",
    "enum_value": "enumValue",
  });
});
/** @internal */
export type TrendValue$Outbound = {
  analog_normalized_value?: number | undefined;
  analog_value?: number | undefined;
  boolean_value?: boolean | undefined;
  enum_value?: string | undefined;
  timestamp: string;
};

/** @internal */
export const TrendValue$outboundSchema: z.ZodType<
  TrendValue$Outbound,
  z.ZodTypeDef,
  TrendValue
> = z.object({
  analogNormalizedValue: z.number().optional(),
  analogValue: z.number().optional(),
  booleanValue: z.boolean().optional(),
  enumValue: z.string().optional(),
  timestamp: z.date().transform(v => v.toISOString()),
}).transform((v) => {
  return remap$(v, {
    analogNormalizedValue: "analog_normalized_value",
    analogValue: "analog_value",
    booleanValue: "boolean_value",
    enumValue: "enum_value",
  });
});

export function trendValueToJSON(trendValue: TrendValue): string {
  return JSON.stringify(TrendValue$outboundSchema.parse(trendValue));
}
export function trendValueFromJSON(
  jsonString: string,
): SafeParseResult<TrendValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TrendValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TrendValue' from JSON`,
  );
}
